var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('mdb-container',[_c('mdb-row',[_c('mdb-card-title',[_c('strong',[_vm._v(" Add or Remove Users")])])],1),_c('mdb-row',[_c('UsersConfig')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }